import BasicTextInput from "components/BasicInputs/BasicTextInput";
import { getOptions } from "components/Input/functions";
import IconLogoPerson2 from "assets/svg/IconLogoPerson2.svg";
import IconLogoBank from "assets/svg/IconLogoBank.svg";
import IconLogoCashier from "assets/svg/IconLogoCashier.svg";
import IconLogoFund from "assets/svg/IconLogoFund.svg";
import IconLogoCheque from "assets/svg/IconLogoCheque.svg";
import { CardProps } from "../../../components/Transaction2/comps/Card";
import posImg from "assets/svg/pos.svg";
import BasicSelect from "components/BasicInputs/BasicSelect";
import NewSwitch from "pages/business/Subscription/NewSwitch";
import { useAppDispatch, useAppSelector } from "store/store";
import { apiPersonsList } from "api/personApi";

function FactorSettings({ settingData, setSettingData }: any) {
  const state = useAppSelector((state) => state);
  const token = state.businessReducer.business.token;
  const dispatch = useAppDispatch();
  const options = getOptions("persons", state);
  const DefaultTransActionOptions: CardProps["options"] = [
    {
      label: "بانک",
      value: "bank",
      icon: IconLogoBank,
    },
    {
      label: "شخص",
      value: "person",
      icon: IconLogoPerson2,
    },
    {
      label: "چک",
      value: "cheque",
      icon: IconLogoCheque,
    },
    {
      label: "خرج چک",
      value: "spendCheque",
      icon: IconLogoCheque,

    },
    {
      label: "تنخواه",
      value: "fund",
      icon: IconLogoFund,
    },
    {
      label: "صندوق",
      value: "cashier",
      icon: IconLogoCashier,
    },
    {
      label: "دستگاه کارت خوان",
      value: "pos",
      icon: posImg,
    }
  ];
  // data
  const defaultData: {
    sectionTitle: string;
    subSection: {
      title: string;
      description: string;
      key: string;
      selectTitle: string | null;
      selectValues: {
        key?: string;
        options?: any;
        inputProps?: BasicSelectProps;
        component?: "BasicSelect" | "TextInput";
        inputOptions?: {
          label: string;
          key: string;
          type: string;
        };
      } | null;
    }[];
  }[] = [
      {
        sectionTitle: "فیلتر فاکتور ها",
        subSection: [
          {
            title: "عدم نمایش فاکتور های ثبت شده توسط کاربر های دیگر",
            description: "مدیر و مالک دسترسی به تمام فاکتور ها دارند",
            key: "ShowOnlyFactorsOfCurrentUser",
            selectTitle: null,
            selectValues: null,
          },
        ]
      },
      {
        sectionTitle: "قیمت کالا/خدمات",
        subSection: [
          {
            title: "به روز رسانی خودکار قیمت فروش پس از ذخیره فاکتور فروش",
            description: "پس از تغییر دستی قیمت فروش هنگام ثبت فاکتور، قیمت فروش محصول به روز رسانی شود",
            key: "AutomaticUpdateSellPriceAfterSavingFactor",
            selectTitle: null,
            selectValues: null,
          },
          {
            title: "به روز رسانی خودکار قیمت خرید پس از ذخیره فاکتور خرید",
            description: "پس از تغییر دستی قیمت خرید هنگام ثبت فاکتور، قیمت خرید محصول به روز رسانی شود",
            key: "AutomaticUpdateBuyPriceAfterSavingFactor",
            selectTitle: null,
            selectValues: null,
          },
        ],
      },
      {
        sectionTitle: "موجودی کالا",
        subSection: [
          {
            title: "اجازه ثبت فاکتور در صورت کمبود موجودی (موجودی حسابداری)",
            description: "",
            key: "NegativeProductBalancePermissionForFactor",

            selectTitle: null,
            selectValues: null,
          },
          {
            title: "اجازه ثبت حواله انبار در صورت کمبود موجودی (موجودی انبار)",
            description: "",
            key: "NegativeProductBalancePermissionForBill",

            selectTitle: null,
            selectValues: null,
          },
          {
            title: "عدم نمایش کالاهایی با موجودی صفر یا منفی در فاکتور فروش",
            description: "",
            key: "ShowAvailableProductsOnFactor",
            selectTitle: null,
            selectValues: null,
          },
        ],
      },
      {
        sectionTitle: "جدول کالا/خدمات",
        subSection: [
          {
            title: "اجازه ثبت ردیف تکراری در فاکتور",
            description: "",
            key: "DuplicateRowsInFactor",
            selectTitle: null,
            selectValues: null,
          },
          {
            title: "غیرفعال کردن مالیات در فاکتور",
            description: "",
            key: "DisableTax",
            selectTitle: null,
            selectValues: null,
          },
        ],
      },
      {
        sectionTitle: "تنظیمات حسابداری فاکتور",
        subSection: [
          // {
          //   title: "نمایش سود در فاکتور",
          //   description: "",
          //   key: "ShowProfitOnFactor",
          //   selectTitle: null,
          //   selectValues: null,
          // },
          {
            title: "اجازه ثبت فاکتور در صورت منفی بودن تراز مالی",
            description: "",
            key: "NegativePersonBalancePermissionForFactor",
            selectTitle: null,
            selectValues: null,
          },
          {
            title: "حذف حواله های انبار قبلی در صورت ویرایش فاکتور",
            description: "",
            key: "shouldUpdateBillAfterEditFactor",
            selectTitle: null,
            selectValues: null,
          },
          {
            title: "تفکیک شماره گذاری فاکتورهای فروش و پیش فاکتور",
            description: "",
            key: "SeparateDraftsAccountingNumber",
            selectTitle: "پیشوند شماره پیش فاکتور",
            selectValues: {
              key: "DraftsAccountingNumberSeparator",
              component: "TextInput",
              inputOptions: {
                label: "پیشوند شماره پیش فاکتور",
                key: "DraftsAccountingNumberSeparator",
                type: "input",
              },
            },
          },
        ],
      },
      {
        sectionTitle: "فاکتور تکرار شونده",
        subSection: [
          {
            title: "پرداخت فاکتور اجباری باشد",
            description: "",
            key: "ForceActiveTransAction",
            selectTitle: null,
            selectValues: null,
          },
          {
            title: "انتخاب شخص پیش فرض به عنوان خریدار",
            description: "یکی از اشخاص ثبت شده به عنوان خریدار پیش فرض در فاکتور جدید انتخاب می شود",
            key: "DefaultCustomer",
            selectTitle: "شخص پیش فرض",
            selectValues: {
              key: "DefaultSelectedPerson",
              options: state.personReducer.allPerson ?? [],
              inputProps: {
                options: state.personReducer.allPerson ?? [],
                withRefresh: true,
                withClear: true,
                onClear: () => {    onChange("DefaultSelectedPerson", 0);},
                refreshList: () => dispatch(apiPersonsList(token, "allPerson")),
                menuStyle: { minWidth: 250 },
              },
            },
          },


          {
            title: "انتخاب روش تسویه فاکتور پیش فرض",
            description: "انتخاب یکی از روش ها در تسویه فاکتور به صورت پیش فرض انتخاب می شود",
            key: "DefaultTransAction",
            selectTitle: " روش تسویه فاکتور پیش فرض",
            selectValues: {
              key: "DefaultTransAction",
              options: DefaultTransActionOptions,
              inputProps: {
                options: DefaultTransActionOptions,
                withClear: true,
                //withRefresh: true,
                //refreshList: () => dispatch(apiPersonsList(token, "allPerson")),
                menuStyle: { minWidth: 250 },
              },
            },
          },
        ],
      },

      // {
      //   sectionTitle: "سند فاکتور",
      //   subSection: [
      //     {
      //       title: "جداسازی شماره فاکتورهای موقت و دائم",
      //       description: "یکی از اشخاص ثبت شده به عنوان خریدار پیش فرض در فاکتور جدید انتخاب می شود",
      //       key: "SeparationTemporaryPermanent",
      //       value: false,
      //       selectTitle: null,
      //       selectValues: null,
      //     },
      //     {
      //       title: "شماره سریال فاکتور",
      //       description: "",
      //       key: "FactorSerialNumber",
      //       selectTitle: "محل درج شماره سریال",
      //       selectValues: {
      //         key: "",
      //         options: [
      //           {
      //             id: 0,
      //             label: "شرح",
      //             value: "test",
      //           },
      //         ],
      //       },
      //     },
      //   ],
      // },
      // {
      //   sectionTitle: "فاکتور آنلاین",
      //   subSection: [
      //     {
      //       title: "فعال سازی ارسال فاکتور آنلاین",
      //       description: "",
      //       key: "OnlineFactor",

      //       selectTitle: "بانک",
      //       selectValues: {
      //         key: "",
      //         options: [
      //           {
      //             id: "1",
      //             label: "شرح",
      //             value: "",
      //           },
      //         ],
      //       },
      //     },
      //   ],
      // },
    ];

  // data

  const onChange = (key: any, value: any) => {
    let temp = {
      ...settingData,
      [key]: value,
    };
    setSettingData(temp);
  };

  const selectedItem = (options: any, key: any, defaultLabel: any) => {
    const keyValue = settingData[key];
    const placeHolder = options?.find((i: { value: any }) => i.value == keyValue);

    return placeHolder?.label || defaultLabel;
  };

  return (
    <div className="flex container flex-col">
      {defaultData.map((item, index) => (
        <div key={index} className="flex flex-col w-full mb-12">
          <span className="text-[#7E8C9E]">{item.sectionTitle}</span>
          {item.subSection?.map((i, index) => (
            <div key={i.key} className="flex flex-row items-start mt-10">
              <NewSwitch
                active={settingData[i.key]}
                size={2}
                activeColor="#30D74B"
                onChange={(value) => onChange(i.key, value)}
              />
              <div className="flex flex-col px-4  ">
                <h1 className="text-base font-medium text-dark-6 ">{i.title}</h1>
                <span className="text-xs font-normal text-dark-3 mt-4">{i?.description}</span>
              </div>
              {i.selectTitle && (
                <div className="flex  flex-1 justify-end">
                  <div className="flex flex-col  items-start">
                    {/* <span className="mb-2">{i.selectTitle}</span> */}
                    {i.selectValues?.component === "TextInput" ? (
                      <div className="flex flex-col">
                        <BasicTextInput
                          fullWidth
                          disabled={!settingData[i.key] ?? undefined}
                          textArea={i.selectValues.inputOptions?.type === "textArea" ? true : false}
                          label={i?.selectValues?.inputOptions?.label ?? ""}
                          onChange={(e) => {
                            onChange(i.selectValues?.key, e);
                          }}
                          // placeHolder={settingData[item.hasInput.key] ?? ""}
                          val={settingData[i.selectValues?.key ?? ""]}
                        />
                        {settingData[i.selectValues?.key ?? ""]?.length > 0 ? (
                          <div className="flex flex-row items-center mx-1 justify-between">
                            <span className="mt-1 text-dark-3 text-xs">پیش نمایش : </span>
                            <span dir="ltr" className="mt-1 text-dark-3 text-xs">
                              {settingData[i.selectValues?.key ?? ""]}-xxxxx
                            </span>
                          </div>
                        ) : null}
                      </div>
                    ) : (
                      <BasicSelect
                        label={i.selectTitle}
                        withSearch
                        withClear
                        options={i?.selectValues?.options ?? []}
                        placeholder={selectedItem(
                          i?.selectValues?.options,
                          i?.selectValues?.key,
                          i?.selectValues?.options[0]?.label
                        )}
                        onChange={(id, _) => {
                          onChange(i?.selectValues?.key, id);
                        }}
                        defaultValue={settingData?.DefaultSelectedPerson ?? null}
                        {...i?.selectValues?.inputProps}
                      />
                    )}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}

export default FactorSettings;
